import React, { useState, useEffect } from 'react'
import VideoBackground from 'components/VideoBackground'
const imageMap = {
    Sneakers: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/images%2Fblack%20yeezys%20pair%20.png?alt=media&token=e766abe5-e48e-4d81-98a1-90d57d1a2a03',

    StreetWear: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2Fhats%20justin.jpg?alt=media&token=816c1aeb-f494-466f-b406-cfcc25254890',

    Skincare: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2Fjoanna%20skincare.jpg?alt=media&token=86224647-8434-4f52-af02-638690c1d293',

    FandF: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2FCJ%20Shirts.jpg?alt=media&token=eaf2b0d2-c74e-4c7e-aade-590dccda80ba',

}

const videomap = {
    Sweaters: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Hats: 'https://httest.s3.amazonaws.com/hats.mp4',

    Skincare: 'https://httest.s3.amazonaws.com/111_aXphX21fZXMyXzE4Ng_Trim+(1).mp4',

    Shirts: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Masks: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Sneakers: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',


}

function headerImage(props) {
        return (
            <div style={{backgroundColor: props.backgroundColor}} className={'stream_header'}>
                <img className='header_img2' src={props.URL}>
                </img>
                <div className='header_wording2'>{props.Type}</div>
            </div>
        )
    
}
export default headerImage

{/* <div className={'stream_header'}>
<img className='header_img' src={imageMap[props.Type]}>
</img>
<div className='header_wording'>{props.Type}</div>
</div> */}



// WEBPACK FOOTER //
// ./src/containers/Stream2/headerDispalyImage.jsx